var React = require('react');

function IconCategory (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M872.5 816.2H403.8c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h468.7c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7zm0-232.6H403.8c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h468.7c29.9 0 54.1 24 54.1 53.7v35.8c0 29.6-24.2 53.7-54.1 53.7zm0-232.7H403.8c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h468.7c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7zM223.6 816.2h-72.1c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h72.1c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7zm0-232.6h-72.1c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h72.1c29.9 0 54.1 24 54.1 53.7v35.8c0 29.6-24.2 53.7-54.1 53.7zm0-232.7h-72.1c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h72.1c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7z"}));
}

IconCategory.displayName = "IconCategory";

IconCategory.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCategory;

IconCategory.default = IconCategory;
